import { render } from "./AttributeMerchant.vue?vue&type=template&id=7073fbe3&scoped=true"
import script from "./AttributeMerchant.vue?vue&type=script&lang=js"
export * from "./AttributeMerchant.vue?vue&type=script&lang=js"

import "./AttributeMerchant.vue?vue&type=style&index=0&id=7073fbe3&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7073fbe3"]])

export default __exports__